/**
 * @fileoverview POST handler for the "/admin/request_impersonation" endpoint
 */
import fetch from "@lib/fetch";
import { fetchCountryCode } from "@lib/impersonation/fetchCountryCode";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { adminRequestImpersonationCacheKeys } from "./constants";
import type { PostAdminRequestImpersonationProps } from "./types";

export const postAdminRequestImpersonation = reactQueryMutationAdapter(
  adminRequestImpersonationCacheKeys,
  async (props: PostAdminRequestImpersonationProps): Promise<any> => {
    // manipulate props here as needed { impersonation_company_id, is_read_only, reason }
    const countryCode = await fetchCountryCode();
    return fetch("/admin/request_impersonation", "POST", {
      ...props,
      country_code: countryCode,
    });
  }
);
